import React from "react";
import compose from "lodash/flowRight";
import withAnalytics from "shared/AnalyticsNew/withAnalytics/withAnalytics";
import ExternalMentorCardWidgetRoutes from "./ExternalMentorCardWidgetRoutes";

const ExternalMentorCardWidget = (props) => {
    return (
        <ExternalMentorCardWidgetRoutes
            universitySlug={props.match.params.universitySlug}
            primaryApp="external-diglett"
            {...props}
        />
    );
};

export default compose(withAnalytics)(ExternalMentorCardWidget);
